export const ADULTING_OPEN_ATTENTION_EVENT = 'adulting:open-attention';

export function openWebAttentionOverlay() {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(ADULTING_OPEN_ATTENTION_EVENT));
}
